import { Request } from '../../Servidor/Request';

export class ResetForgottenPasswordRequest {
    private token: string;
    private novaSenha: string;

    constructor(token: string, novaSenha: string) {
        this.token = token;
        this.novaSenha = novaSenha;
    }

    /** Getter token */
    public getToken(): string {
        return this.token;
    }

    /** Getter novaSenha */
    public getNovaSenha(): string {
        return this.novaSenha;
    }
}

export class ResetForgottenPasswordInteractor {
    public fetchSave(request: ResetForgottenPasswordRequest): Promise<boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("login/redefinir-senha", request).then((rs) => {
                if (!rs) {
                    return rej({ Mensagem: "Erro ao conectar" });
                }

                const sucesso = rs.Status === "Sucesso";
                res(sucesso);
            }, (e) => {
                rej(e)
            }
            );
        });
    }
}
